module.exports = __webpack_public_path__ + "static/ITUT27-f7b3a0d88bf866df3b18e8b2aad23672.jpg";